import React from 'react';
import Icon from '../../../components/AppIcon';

const TenantMetrics = ({ tenants }) => {
  const totalOccupiedSeats = tenants?.reduce((sum, tenant) => sum + tenant?.seatsTaken, 0);
  const totalMonthlyRevenue = tenants?.reduce((sum, tenant) => sum + tenant?.monthlyRevenue, 0);
  
  const getExpiringTenants = () => {
    const today = new Date();
    return tenants?.filter(tenant => {
      const lockInEnd = new Date(tenant.lockinEndDate);
      const diffTime = lockInEnd - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays <= 60 && diffDays > 0;
    });
  };

  const expiringTenants = getExpiringTenants();

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  const metrics = [
    {
      title: 'Total Tenants',
      value: tenants?.length,
      icon: 'Users',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      title: 'Occupied Seats',
      value: totalOccupiedSeats,
      icon: 'MapPin',
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      title: 'Monthly Revenue',
      value: formatCurrency(totalMonthlyRevenue),
      icon: 'DollarSign',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      title: 'Expiring Soon',
      value: expiringTenants?.length,
      icon: 'AlertTriangle',
      color: 'text-amber-600',
      bgColor: 'bg-amber-100'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
      {metrics?.map((metric, index) => (
        <div key={index} className="bg-white rounded-lg border border-gray-200 p-4 md:p-6 shadow-sm">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-600 mb-1">
                {metric?.title}
              </p>
              <p className="text-2xl md:text-3xl font-bold text-gray-900">
                {metric?.value}
              </p>
            </div>
            <div className={`flex-shrink-0 w-12 h-12 ${metric?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon 
                name={metric?.icon} 
                size={24} 
                className={metric?.color}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TenantMetrics;